import React from "react"
import { Player, BigPlayButton, ControlBar } from "video-react"
import { classNames } from "../../../../helpers/classNames"
import type { VideoData } from "../../../../constants/types"

type GuideVideoProps = {
  data: VideoData
  list: boolean
  preview: boolean
  full: boolean
}

export const GuideVideo: React.FC<GuideVideoProps> = ({ data, list, preview, full }) => {
  const classes = classNames({
    "video-container": true,
    list,
    preview,
    fullsize: full
  })

  return (
    <div className={classes}>
      <Player src={data.url} className="video-player" height={preview ? 150 : 600} fluid={!full}>
        <BigPlayButton position="center" />
        <ControlBar disableCompletely={!full} />
      </Player>
    </div>
  )
}
